import { paymentMapper } from '../mappers/payment-mapper';
import { apiClient } from '../shared/api-client';
import { logError } from '../shared/error-logger';

const paymentRepository = {
    async getAll() {
        try {
            const list = await apiClient.get({
                url: 'payments'
            });

            return list.map(paymentMapper.toDomain);
        } catch (error) {
            logError(error);

            return [];
        }
    }
};

export {
    paymentRepository
};
